import { useState, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import "../styles/AuthModal.css";
import { AuthContext } from "./AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function AuthModal() {
  // "login" | "register" | "reset_request" | "reset_confirm"
  const [mode, setMode] = useState("login");

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState(""); // użyjemy też do reset_request
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  const [resetUid, setResetUid] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [acceptedLegal, setAcceptedLegal] = useState(false);

  const { login, register } = useContext(AuthContext);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // ✅ helper: pobierz uid/token z query string
  const getResetParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      uid: params.get("uid") || "",
      token: params.get("token") || "",
    };
  };

  // ✅ Jeśli user wejdzie z linku resetu (np. /reset-hasla?uid=...&token=...)
  // to automatycznie przełącz modal w tryb ustawienia nowego hasła i otwórz modal.
  useEffect(() => {
    const { uid, token } = getResetParams();
    if (window.location.pathname === "/reset-hasla" && uid && token) {
      setMode("reset_confirm");
      setError("");
      setInfo("");

      // otwórz modal bootstrapem
      const modalEl = document.getElementById("authModal");
      if (modalEl && window.bootstrap?.Modal) {
        const instance =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);
        instance.show();
      }
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/email-verified") {
      setMode("login");
      setError("");
      setInfo("");

      // otwórz modal bootstrapem
      const modalEl = document.getElementById("authModal");
      if (modalEl && window.bootstrap?.Modal) {
        const instance =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);
        instance.show();
      }
    }
  }, []);

  const closeModal = () => {
    const modalEl = document.getElementById("authModal");
    const modalInstance = window.bootstrap?.Modal?.getInstance(modalEl);
    modalInstance?.hide();

    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
  };

  const clearForm = () => {
    setUsername("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
  };

  useEffect(() => {
    const raw = sessionStorage.getItem("pwReset");
    if (!raw) return;

    try {
      const { uid, token } = JSON.parse(raw);
      if (!uid || !token) return;

      setResetUid(uid);
      setResetToken(token);

      console.log("Test")
      console.log(raw)
      console.log(uid)
      console.log(token)
      console.log(resetUid)
      console.log(resetToken)

      // przełącz tryb
      setMode("reset_confirm");
      setError("");
      setInfo("");
      setPassword("");
      setConfirmPassword("");

      // otwórz modal po renderze
      setTimeout(() => {
        const modalEl = document.getElementById("authModal");
        if (modalEl && window.bootstrap?.Modal) {
          const instance =
            window.bootstrap.Modal.getInstance(modalEl) ||
            new window.bootstrap.Modal(modalEl);
          instance.show();
        }
      }, 0);
    } finally {
      // ✅ usuń, żeby po odświeżeniu nie otwierało ponownie
      sessionStorage.removeItem("pwReset");
    }
    
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setInfo("");

    try {
      // ✅ LOGIN
      if (mode === "login") {
        const success = await login(username, password);
        if (!success) {
          throw new Error("Niepoprawne dane logowania lub konto nieaktywne");
        }

        closeModal();
        clearForm();
        return;
      }

      // ✅ REGISTER
      if (mode === "register") {
        if (!acceptedLegal) {
          throw new Error("Aby utworzyć konto, musisz zaakceptować regulamin i politykę prywatności.");
        }
        if (password !== confirmPassword) {
          throw new Error("Hasła muszą być identyczne");
        }

        const success = await register(username, email, password);
        if (!success) {
          throw new Error("Nie udało się zarejestrować");
        }

        setInfo(
          "Konto zostało utworzone. Sprawdź skrzynkę e-mail i aktywuj konto, aby się zalogować."
        );
        setMode("login");
        setPassword("");
        setConfirmPassword("");
        return;
      }

      // ✅ RESET REQUEST (wysyłka maila z linkiem)
      if (mode === "reset_request") {
        const res = await fetch(`${API_BASE}/api/users/password-reset/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        // backend i tak powinien zwracać 200 zawsze, ale obsłużmy "na wszelki"
        if (!res.ok) {
          throw new Error("Nie udało się wysłać linku resetu hasła.");
        }

        setInfo("Jeśli konto istnieje, wysłaliśmy e-mail z linkiem resetu hasła.");
        return;
      }

      // ✅ RESET CONFIRM (ustawienie nowego hasła)
      if (mode === "reset_confirm") {
        if (password !== confirmPassword) {
          throw new Error("Hasła muszą być identyczne");
        }

        // const { uid, token } = getResetParams();
        // if (!uid || !token) {
        //   throw new Error("Brak lub niepoprawny link resetu hasła.");
        // }
        console.log(resetToken,resetUid)
        if (!resetUid || !resetToken) {
          throw new Error("Brak lub niepoprawny link resetu hasła.");
        }

        const uid = resetUid
        const token = resetToken
        const res = await fetch(`${API_BASE}/api/users/password-reset-confirm/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid,
            token,
            new_password1: password,
            new_password2: confirmPassword,
          }),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data?.detail || "Nie udało się zmienić hasła.");
        }

        setInfo("Hasło zostało zmienione. Możesz się teraz zalogować.");
        setMode("login");
        setUsername("");
        setPassword("");
        setConfirmPassword("");

        // opcjonalnie: wyczyść URL po resecie (żeby nie wchodzić w tryb resetu po refreshu)
        window.history.replaceState({}, "", "/");
        return;
      }
    } catch (err) {
      setError(err.message || "Wystąpił błąd");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  // reset akceptacji przy każdej zmianie trybu
  setAcceptedLegal(false);
}, [mode]);

  const title =
    mode === "login"
      ? "Zaloguj się"
      : mode === "register"
      ? "Utwórz konto"
      : mode === "reset_request"
      ? "Reset hasła"
      : "Ustaw nowe hasło";

  const subtitle =
    mode === "login"
      ? "Witaj ponownie 👋 Wprowadź swoje dane, aby kontynuować."
      : mode === "register"
      ? "Dołącz do społeczności i odkrywaj wydarzenia!"
      : mode === "reset_request"
      ? "Podaj e-mail — wyślemy link do ustawienia nowego hasła."
      : "Wpisz nowe hasło dla swojego konta.";

  const submitLabel = loading
    ? mode === "login"
      ? "Logowanie..."
      : mode === "register"
      ? "Rejestrowanie..."
      : mode === "reset_request"
      ? "Wysyłanie..."
      : "Zapisywanie..."
    : mode === "login"
    ? "Zaloguj się"
    : mode === "register"
    ? "Zarejestruj się"
    : mode === "reset_request"
    ? "Wyślij link resetu"
    : "Zmień hasło";


  

  return createPortal(
  <div
    className="modal fade"
    id="authModal"
    tabIndex="-1"
    aria-labelledby="authModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      {/* zamiast modal-content glass-auth */}
      <div className="modal-content auth-shell" role="dialog" aria-modal="true">
        {/* glass frame */}
        <div className="auth-shell__frame" />

        {/* inner panel */}
        <div className="auth-shell__panel">
          <button
            type="button"
            className="auth-shell__close"
            data-bs-dismiss="modal"
            aria-label="Zamknij"
            onClick={() => {
              setError("");
              setInfo("");
            }}
          />

          <div className="auth-shell__body">
            <h3 className="auth-shell__title">{title}</h3>

            {subtitle && (
              <p className="auth-shell__subtitle">{subtitle}</p>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              {/* USERNAME tylko login/register */}
              {(mode === "login" || mode === "register") && (
                <div className="auth-field">
                  <label className="auth-field__label">Nazwa użytkownika lub adres e-mail</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="auth-field__input"
                    placeholder="Nazwa użytkownika"
                    required
                  />
                </div>
              )}

              {/* EMAIL tylko register/reset_request */}
              {(mode === "register" || mode === "reset_request") && (
                <div className="auth-field">
                  <label className="auth-field__label">E-mail</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="auth-field__input"
                    placeholder="E-mail"
                    required
                  />
                </div>
              )}

              {/* PASSWORD */}
              {(mode === "login" || mode === "register" || mode === "reset_confirm") && (
                <div className="auth-field">
                  <label className="auth-field__label">
                    {mode === "reset_confirm" ? "Nowe hasło" : "Hasło"}
                  </label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="auth-field__input"
                    placeholder={mode === "reset_confirm" ? "Nowe hasło" : "Hasło"}
                    required
                  />
                </div>
              )}

              {/* CONFIRM */}
              {(mode === "register" || mode === "reset_confirm") && (
                <div className="auth-field">
                  <label className="auth-field__label">
                    {mode === "reset_confirm" ? "Potwierdź nowe hasło" : "Potwierdź hasło"}
                  </label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="auth-field__input"
                    placeholder={mode === "reset_confirm" ? "Potwierdź nowe hasło" : "Potwierdź hasło"}
                    required
                  />
                </div>
              )}

              {error && <div className="auth-alert auth-alert--error">{error}</div>}
              {info && <div className="auth-alert auth-alert--success">{info}</div>}

              {mode === "register" && (
                <div className="auth-legal">
                  <label className="auth-legal__row">
                    <input
                      type="checkbox"
                      className="auth-legal__checkbox"
                      checked={acceptedLegal}
                      onChange={(e) => setAcceptedLegal(e.target.checked)}
                      required
                    />
                    <span className="auth-legal__text">
                      Oświadczam, że zapoznałem(-am) się i akceptuję{" "}
                      <a
                        href="/regulamin-serwisu"
                        target="_blank"
                        rel="noreferrer"
                        className="auth-legal__link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Regulamin serwisu
                      </a>{" "}
                      oraz{" "}
                      <a
                        href="/polityka-prywatnosci"
                        target="_blank"
                        rel="noreferrer"
                        className="auth-legal__link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Politykę prywatności i cookies
                      </a>
                      .
                    </span>
                  </label>
                </div>
              )}

              <button
                type="submit"
                className="auth-cta"
                disabled={loading || (mode === "register" && !acceptedLegal)}
              >
                {submitLabel}
              </button>

              {/* Nie pamiętasz hasła? */}
              {mode === "login" && (
                <div className="auth-forgot">
                  <button
                    type="button"
                    className="auth-link"
                    onClick={() => {
                      setMode("reset_request");
                      setError("");
                      setInfo("");
                      setPassword("");
                      setConfirmPassword("");
                    }}
                  >
                    Nie pamiętasz hasła?
                  </button>
                </div>
              )}
            </form>

            {/* dolny switcher */}
            <div className="auth-footer">
              {mode === "login" && (
                <div className="auth-footer__row">
                  <span className="auth-footer__text">Nie masz konta?</span>{" "}
                  <button
                    className="auth-footer__link"
                    onClick={() => {
                      setMode("register");
                      setError("");
                      setInfo("");
                    }}
                    type="button"
                  >
                    Zarejestruj się.
                  </button>
                </div>
              )}

              {mode === "register" && (
                <div className="auth-footer__row">
                  <span className="auth-footer__text">Masz już konto?</span>{" "}
                  <button
                    className="auth-footer__link"
                    onClick={() => {
                      setMode("login");
                      setError("");
                      setInfo("");
                    }}
                    type="button"
                  >
                    Zaloguj się.
                  </button>
                </div>
              )}

              {mode === "reset_request" && (
                <div className="auth-footer__row">
                  <span className="auth-footer__text">Wróć do</span>{" "}
                  <button
                    className="auth-footer__link"
                    onClick={() => {
                      setMode("login");
                      setError("");
                      setInfo("");
                      setEmail("");
                    }}
                    type="button"
                  >
                    logowania.
                  </button>
                </div>
              )}

              {mode === "reset_confirm" && (
                <div className="auth-footer__row">
                  <span className="auth-footer__text">Wróć do</span>{" "}
                  <button
                    className="auth-footer__link"
                    onClick={() => {
                      setMode("login");
                      setError("");
                      setInfo("");
                      setPassword("");
                      setConfirmPassword("");
                      window.history.replaceState({}, "", "/");
                    }}
                    type="button"
                  >
                    logowania.
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* /auth-shell */}
    </div>
  </div>,
  document.body
);

}
